// src/TopPage.jsx
import React from 'react';
import { Box, Button, Typography, Paper } from '@mui/material';
import sdgsImage from './sdgs12_image1.jpg'; 
import ecotechlLogo from './ecotechl_logo.jpg';
import ecotechlImage from './ecotechl_image1.jpg';

const TopPage = ({ onStart }) => {

  const features = [
    {
      text: '✔️ 充実した機能',
      text2: '・スマホでＱＲコード読込んで簡単排出登録',
      text3: '・担当者作業報告機能、請求書作成機能等々',
      url: 'https://www.ecotechl.com/sdgs12system/#jyuujitukinou', // それぞれのURLを指定
    },
    {
      text: '✔️ 迅速なサポート',
      text2: '・タイムリーなマニフェストの修正・取消',
      text3: '・ユーザーニーズへのカスタマイズ対応　',
      url: 'https://www.ecotechl.com/sdgs12system/#jinsokusupport',
    },
    {
      text: '✔️ 利用しやすい価格',
      text2: '・月額基本料なし、使った分だけの利用料です',
      text3: '・マニフェスト保存義務期間５年分を含みます',
      url: 'https://www.ecotechl.com/sdgs12system/#riyoukakaku',
    },
  ];
  
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start', // 上から順に表示
        padding: 2,
        textAlign: 'center',
      }}
    >
    <table style={{ width: '60%', padding: '0 16px', borderCollapse: 'collapse', border: 'none' }}>
      <tbody>
        <tr style={{ margin: 0, padding: 0 }}> {/* 行間をなくすためにスタイルを追加 */}
          <td style={{ textAlign: 'left', border: 'none', padding: 0 }}> {/* paddingを0に設定 */}
              <img
                src={ecotechlLogo}
                alt="Ecotechl Logo"
                style={{
                  maxWidth: '600px', // ロゴのサイズを調整
                  height: 'auto',
                }}
              />
          </td>
        </tr>
        <tr style={{ margin: 0, padding: 0 }}> {/* 行間をなくすためにスタイルを追加 */}
          <td style={{ textAlign: 'right', border: 'none', padding: 0 }}> {/* paddingを0に設定 */}
            <Button
              variant="outlined"
              color="primary"
              size="large"
              style={{ margin: '0 8px' }}
              onClick={() => window.open('https://www.ecotechl.com/contactform/', '_blank', 'noopener,noreferrer')}
            >
              お問い合わせ
            </Button>
            <Button
              variant="outlined"
              color="primary"
              size="large"
              style={{ margin: '0 8px' }}
              onClick={() => window.open('https://www.ecotechl.com/demoform/', '_blank', 'noopener,noreferrer')}
            >
              デモ申込
            </Button>
            <Button variant="outlined" color="primary" size="large" style={{ margin: '0 8px' }} onClick={onStart}>
              ログイン
            </Button>
          </td>
        </tr>
      </tbody>
    </table>

      <Typography variant="h2" gutterBottom>
        産業廃棄物SDGｓ推進システム
      </Typography>
      <Typography variant="h3" gutterBottom>
        （SDGs12システム）
      </Typography>
      <Typography variant="h5" gutterBottom>
        私たちのサービスへようこそ！<br />
        SDGs12システムは、産業廃棄物のトレーサビリティを推進し、環境保全や資源循環に貢献します。<br />
        ＱＲコードで簡単に電子マニフェスト（JWNET）登録でき、廃棄物一覧で運搬・処分状況を管理できます。
      </Typography>
      {/* 画像を表示 */}
      <img
        src={sdgsImage}
        alt="SDGs12"
        style={{
          maxWidth: '100%', // レスポンシブ対応
          height: 'auto', // 高さを自動調整
          marginBottom: '16px', // 画像とテキストの間にスペースを追加
        }}
      />
      <Typography variant="body1" sx={{ marginBottom: 0 }}>
        私たちのサービスは、以下の特徴を持っています：
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: 0,
        }}
      >
        {features.map((feature, index) => (
          <Paper
            key={index}
            sx={{
              margin: 4,
              padding: 3,
              textAlign: 'center',
              cursor: 'pointer',
              transition: 'background-color 0.3s',
              backgroundColor: '#e3f2fd', // 薄青色の背景
              '&:hover': {
                backgroundColor: '#ffcccb', // マウスオーバー時の色
              },
            }}
            onClick={() => window.open(feature.url, '_blank', 'noopener,noreferrer')}
          >
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>{feature.text}</Typography>
            <Typography variant="body2" sx={{ marginTop: 1 }}>{feature.text2}</Typography> {/* 追加のテキスト */}
            <Typography variant="body2" sx={{ marginTop: 1 }}>{feature.text3}</Typography> {/* 追加のテキスト */}
          </Paper>
        ))}
      </Box>
      <Button variant="contained" color="primary" onClick={onStart}>
        サービス利用を始める
      </Button>
      {/* 画像を表示 */}
      <img
        src={ecotechlImage}
        alt="ecotechlimage"
        style={{
          maxWidth: '100%', // レスポンシブ対応
          height: 'auto', // 高さを自動調整
          marginBottom: '16px', // 画像とテキストの間にスペースを追加
        }}
      />
    </Box>
  );
};

export default TopPage;